/**
 * Spinner Render
 *
 * DOM rendering helpers for overlay and inline spinner elements.
 */

interface SpinnerOverlayConfig {
    message?: string | null;
}

interface InlineSpinnerOptions {
    size?: "normal" | "small";
}

class SpinnerRender {
    public static createOverlay(config: SpinnerOverlayConfig): HTMLDivElement {
        const overlay = document.createElement("div");
        overlay.className = "loading-overlay";

        const content = document.createElement("div");
        content.className = "loading-content";

        const textHtml = config.message ? `<div class="loading-text">${config.message}</div>` : "";

        content.innerHTML = `
            <div class="spinner"></div>
            ${textHtml}
        `;

        overlay.appendChild(content);
        return overlay;
    }

    public static createButtonSpinner(): HTMLSpanElement {
        const spinner = document.createElement("span");
        spinner.className = "btn-spinner";
        spinner.innerHTML = '<div class="spinner spinner-small"></div>';
        return spinner;
    }

    public static createInlineSpinner(options: InlineSpinnerOptions = {}): HTMLDivElement {
        const size = options.size || "normal";
        const spinner = document.createElement("div");
        spinner.className = size === "small" ? "spinner spinner-small" : "spinner";
        return spinner;
    }

    public static createFormSpinner(message: string): HTMLDivElement {
        const overlay = document.createElement("div");
        overlay.className = "form-spinner-overlay";
        overlay.innerHTML = `
            <div class="spinner"></div>
            <div class="loading-text">${message}</div>
        `;
        return overlay;
    }
}

export { SpinnerRender };
